<template>
  <v-btn
    class="mx-1 px-0"
    rounded="lg"
    min-width="40"
    elevated="26"
    color="#ECE6F0"
    @click="props.cloneAction()"
  >
    <v-icon
      color="#0F6DAC"
      size="x-large"
    >
      mdi-plus
    </v-icon>
  </v-btn>
  <v-btn
    class="mx-1 px-0"
    rounded="lg"
    min-width="40"
    elevated="26"
    color="#ECE6F0"
    @click="props.editAction()"
  >
    <v-icon
      color="#0F6DAC"
      size="x-large"
    >
      mdi-pencil
    </v-icon>
  </v-btn>
  <v-btn
    class="mx-1 px-0"
    rounded="lg"
    min-width="40"
    elevated="26"
    color="#F2B8B5"
    @click="deleteWithConfirmation()"
  >
    <v-icon
      color="white"
      size="x-large"
    >
      mdi-delete
    </v-icon>
  </v-btn>
</template>

<script setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";

const props = defineProps({
  cloneAction: {
    type: Function,
    required: true
  },
  editAction: {
    type: Function,
    required: true
  },
  deleteAction: {
    type: Function,
    required: true
  }
});

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const deleteWithConfirmation = () => {
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "error" },
    title: t("actions.confirmation.delete.title"),
    content: t("actions.confirmation.delete.content"),
    confirmationText: t("actions.confirmation.delete.confirm"),
    cancellationText: t("actions.confirmation.delete.cancel"),
    confirmationButtonProps: { color: "warning" }
  }).then((confirm) => {
    if (confirm) {
      props.deleteAction();
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
};
</script>
